// forms stream: form workflows (registry, drafts, preparation documents, holders).
export const en: Record<string, string> = {
  "forms.title": "Forms",
  "forms.subtitle": "Prepare the eleven workflows your office uses most. Answers are prefilled from the file; nothing is guessed.",
  "forms.providerDemo": "Demo mode: this produces an agency-branded preparation worksheet marked DEMO, not an issued ACORD form. The licensed form comes from your forms provider once connected.",
  "forms.providerLive": "Licensed output through the connected forms provider.",
  "forms.group.certificate": "Certificates",
  "forms.group.evidence": "Evidence of insurance",
  "forms.group.service": "Service forms",
  "forms.group.application": "Commercial applications",
  "forms.workflow": "ACORD {n} workflow",
  "forms.intendedEdition": "Intended edition",
  "forms.needsHolder": "Needs a certificate holder",
  "forms.start": "Start",
  "forms.startTitle": "Start a form workflow",
  "forms.pickCustomer": "Customer",
  "forms.searchCustomer": "Search by name, phone or policy…",
  "forms.pickPolicy": "Policy",
  "forms.noPolicies": "This customer has no policies. Add one on the customer page first.",
  "forms.pickHolder": "Certificate holder / additional interest",
  "forms.noHolder": "No holder yet",
  "forms.addHolder": "Add holder",
  "forms.holderName": "Holder name",
  "forms.holderAddress": "Address",
  "forms.holderEmail": "Email for delivery",
  "forms.holderRequirements": "Requirements",
  "forms.req.additional_insured": "Additional insured",
  "forms.req.waiver_of_subrogation": "Waiver of subrogation",
  "forms.req.primary_noncontributory": "Primary & non-contributory",
  "forms.req.loss_payee": "Loss payee",
  "forms.req.mortgagee": "Mortgagee",
  "forms.req.lienholder": "Lienholder",
  "forms.req.notice_30_days": "30-day notice",
  "forms.holderSaved": "Holder saved",
  "forms.startNow": "Start workflow",
  "forms.started": "Workflow started",
  "forms.history": "Drafts and history",
  "forms.noDrafts": "No form drafts yet. Start one above.",
  "forms.version": "v{n}",
  "forms.status.draft": "Draft",
  "forms.status.generated": "Generated",
  "forms.unanswered": "{n} unanswered",
  "forms.prefilledFrom": "from file",
  "forms.prefilledCount": "{n} answers filled from the file",
  "forms.missingTitle": "Unanswered",
  "forms.missingBody": "These must be answered by the insured or the office. Nothing is assumed.",
  "forms.allAnswered": "Everything required is answered.",
  "forms.save": "Save answers",
  "forms.saved": "Answers saved",
  "forms.generate": "Generate document",
  "forms.generateWithMissing": "Generate anyway (lists unanswered)",
  "forms.generated": "Document generated",
  "forms.preview": "Preview",
  "forms.download": "Download PDF",
  "forms.regenerate": "Regenerate",
  "forms.demoBanner": "DEMO — Not valid proof of insurance. Original preparation worksheet; not an issued ACORD form.",
  "forms.targetForm": "Target form",
  "forms.state": "State",
  "forms.documentId": "Internal document id",
  "forms.draftRef": "Draft",
  "forms.addRow": "Add row",
  "forms.removeRow": "Remove",
  "forms.unknown": "Unknown / not answered",
  "forms.customerPanel.title": "Form workflows",
  "forms.customerPanel.prepare": "Prepare a form",
  "forms.customerPanel.holders": "Certificate holders & additional interests",
  "forms.customerPanel.noHolders": "No holders on file yet.",
  "forms.customerPanel.edit": "Edit",
  "forms.open": "Open",
  "forms.lines": "Lines",
  "forms.pickOne": "Choose…",
  "forms.signature.in_person": "In person",
  "forms.signature.e_sign": "E-signature",
  "forms.signature.email_pdf": "Email PDF for signature",
};

export const es: Record<string, string> = {
  "forms.title": "Formularios",
  "forms.subtitle": "Prepara los once flujos que más usa tu oficina. Las respuestas se llenan desde el expediente; nada se inventa.",
  "forms.providerDemo": "Modo demo: produce una hoja de preparación con la marca de la agencia marcada DEMO, no un formulario ACORD emitido. El formulario con licencia viene de tu proveedor de formularios una vez conectado.",
  "forms.providerLive": "Salida con licencia a través del proveedor de formularios conectado.",
  "forms.group.certificate": "Certificados",
  "forms.group.evidence": "Evidencia de seguro",
  "forms.group.service": "Formularios de servicio",
  "forms.group.application": "Solicitudes comerciales",
  "forms.workflow": "Flujo ACORD {n}",
  "forms.intendedEdition": "Edición prevista",
  "forms.needsHolder": "Requiere titular del certificado",
  "forms.start": "Iniciar",
  "forms.startTitle": "Iniciar un flujo de formulario",
  "forms.pickCustomer": "Cliente",
  "forms.searchCustomer": "Buscar por nombre, teléfono o póliza…",
  "forms.pickPolicy": "Póliza",
  "forms.noPolicies": "Este cliente no tiene pólizas. Agrega una en la página del cliente primero.",
  "forms.pickHolder": "Titular del certificado / interés adicional",
  "forms.noHolder": "Sin titular aún",
  "forms.addHolder": "Agregar titular",
  "forms.holderName": "Nombre del titular",
  "forms.holderAddress": "Dirección",
  "forms.holderEmail": "Correo para envío",
  "forms.holderRequirements": "Requisitos",
  "forms.req.additional_insured": "Asegurado adicional",
  "forms.req.waiver_of_subrogation": "Renuncia de subrogación",
  "forms.req.primary_noncontributory": "Primaria y no contributiva",
  "forms.req.loss_payee": "Beneficiario de pérdida",
  "forms.req.mortgagee": "Hipotecario",
  "forms.req.lienholder": "Acreedor prendario",
  "forms.req.notice_30_days": "Aviso de 30 días",
  "forms.holderSaved": "Titular guardado",
  "forms.startNow": "Iniciar flujo",
  "forms.started": "Flujo iniciado",
  "forms.history": "Borradores e historial",
  "forms.noDrafts": "Aún no hay borradores. Inicia uno arriba.",
  "forms.version": "v{n}",
  "forms.status.draft": "Borrador",
  "forms.status.generated": "Generado",
  "forms.unanswered": "{n} sin responder",
  "forms.prefilledFrom": "del expediente",
  "forms.prefilledCount": "{n} respuestas llenadas desde el expediente",
  "forms.missingTitle": "Sin responder",
  "forms.missingBody": "Deben responderlas el asegurado o la oficina. No se asume nada.",
  "forms.allAnswered": "Todo lo requerido está respondido.",
  "forms.save": "Guardar respuestas",
  "forms.saved": "Respuestas guardadas",
  "forms.generate": "Generar documento",
  "forms.generateWithMissing": "Generar de todos modos (lista lo pendiente)",
  "forms.generated": "Documento generado",
  "forms.preview": "Vista previa",
  "forms.download": "Descargar PDF",
  "forms.regenerate": "Regenerar",
  "forms.demoBanner": "DEMO — No es comprobante válido de seguro. Hoja de preparación original; no es un formulario ACORD emitido.",
  "forms.targetForm": "Formulario objetivo",
  "forms.state": "Estado",
  "forms.documentId": "Id interno del documento",
  "forms.draftRef": "Borrador",
  "forms.addRow": "Agregar fila",
  "forms.removeRow": "Quitar",
  "forms.unknown": "Desconocido / sin responder",
  "forms.customerPanel.title": "Flujos de formularios",
  "forms.customerPanel.prepare": "Preparar un formulario",
  "forms.customerPanel.holders": "Titulares de certificado e intereses adicionales",
  "forms.customerPanel.noHolders": "Aún no hay titulares en el expediente.",
  "forms.customerPanel.edit": "Editar",
  "forms.open": "Abrir",
  "forms.lines": "Líneas",
  "forms.pickOne": "Elegir…",
  "forms.signature.in_person": "En persona",
  "forms.signature.e_sign": "Firma electrónica",
  "forms.signature.email_pdf": "Enviar PDF por correo para firma",
};
